import styled from "styled-components";
import {Container} from "@mui/material";
import {CheckboxInput} from "../../../components/Inputs/CheckboxInput";
import {StyledButton} from "../../../components/Buttons/DefaultButton/DefaultButton.styles";

export const BasicContainer = styled(Container)`
    overflow: auto;
    height: 100%;
    padding: 24px 20px 40px;
    max-width: 1000px !important;
    background-color: #f8f9fa;
    
    @media (max-width: 1024px) {
        max-width: 100% !important;
        padding: 20px 16px 32px;
    }
    
    @media (max-width: 768px) {
        padding: 12px 12px 24px;
    }
`

const cardStyle = `
    background: #FFFFFF;
    margin: 0 0 16px 0;
    border-radius: 12px;
    border: 1px solid var(--divider, #E0E0E0);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`

export const AddressSection = styled.div`
    ${cardStyle}
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 24px;
    gap: 24px;
    
    .subtitle {
        color: var(--text-secondary, #666);
        font-size: 14px;
        margin-top: 4px;
        line-height: 1.5;
    }
    
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 16px;
        gap: 16px;
    }
`

export const DateSection = styled.div`
    ${cardStyle}
    padding: 20px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: var(--text-primary, #222);
    background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
    
    .calendar-date {
        display: flex;
        align-items: center;
        gap: 10px;
        color: var(--primary-blue, #0B4598);
        font-weight: 600;
    }
    
    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        padding: 16px;
        font-size: 14px;
    }
`

export const BillingSection = styled.div`
    ${cardStyle}
    padding: 24px;
    
    @media (max-width: 1024px) {
        padding: 20px;
    }
    
    @media (max-width: 768px) {
        padding: 16px;
    }
`

export const PaymentSection = styled.div`
    ${cardStyle}
    padding: 24px;
    
    @media (max-width: 1024px) {
        padding: 20px;
    }
    
    @media (max-width: 768px) {
        padding: 16px;
    }
`

export const BillingRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    color: var(--text-secondary, #666);
    font-size: 15px;
    border-bottom: 1px solid var(--divider, #f0f0f0);
    &.billable-duration-row {
        gap: 12px;
        align-items: flex-start;
        > div:first-child { flex-shrink: 0; }
        > div:last-child { min-width: 0; text-align: right; }
    }
    
    &:last-child {
        border-bottom: none;
        border-top: 2px solid var(--divider, #E0E0E0);
        padding-top: 16px;
        margin-top: 8px;
    }
    
    &.grand-total {
        font-weight: 700 !important;
        color: var(--text-primary, #222) !important;
        font-size: 18px !important;
    }
    
    @media (max-width: 768px) {
        font-size: 14px;
        padding: 10px 0;
        
        &.grand-total {
            font-size: 16px !important;
        }
    }
`

export const SectionTitle = styled.div`
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--text-primary, #222);
    
    &.title {
        margin-bottom: 6px;
        font-size: 18px;
    }
    
    @media (max-width: 768px) {
        font-size: 15px;
        
        &.title {
            font-size: 16px;
        }
    }
`

export const PaymentInfo = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    font-size: 14px;
    color: var(--text-secondary, #666);
    gap: 16px;
    
    &:not(:last-child) {
        border-bottom: 1px solid var(--divider, #f0f0f0);
    }
    
    div .payment-terms {
        font-weight: 600 !important;
        color: var(--primary-blue, #0B4598) !important;
        text-transform: capitalize;
    }
    
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 4px;
        font-size: 13px;
    }
`

export const StyledCheckboxInput = styled(CheckboxInput)`
    ${cardStyle}
    padding: 18px;
    font-size: 13px;
    line-height: 1.5;
    
    @media (max-width: 768px) {
        padding: 14px;
        font-size: 12px;
    }
`

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
    
    @media (min-width: 600px) {
        flex-direction: row;
        gap: 16px;
        
        > button {
            flex: 1;
        }
    }
`

export const PayNowButton = styled(StyledButton)`
    width: 100%;
    margin: 0;
    padding: 14px 20px !important;
    background: var(--success-main, #13CA82) !important;
    color: #ffffff !important;
    border: 1px solid var(--success-main, #13CA82) !important;
    box-shadow: 0 2px 6px rgba(19, 202, 130, 0.2) !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    
    &:hover {
        background: #0fb876 !important;
        border-color: #0fb876 !important;
        box-shadow: 0 4px 12px rgba(19, 202, 130, 0.3) !important;
    }
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    
    @media (max-width: 768px) {
        font-size: 15px !important;
        padding: 12px 18px !important;
    }
`

export const AlreadyPaidButton = styled(StyledButton)`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    margin: 0;
    padding: 12px 16px !important;
    color: var(--primary-blue, #0B4598) !important;
    background: #ffffff !important;
    border: 1px solid var(--primary-blue, #0B4598) !important;
    box-shadow: none !important;
    font-weight: 500 !important;
    
    &:hover {
        background: rgba(11, 69, 152, 0.06) !important;
        border-color: var(--primary-blue, #0B4598) !important;
        box-shadow: 0 2px 6px rgba(11, 69, 152, 0.15) !important;
    }
    
    @media (max-width: 768px) {
        font-size: 14px !important;
        padding: 10px 14px !important;
    }
`

export const PaymentNote = styled.div`
    ${cardStyle}
    padding: 16px;
    font-size: 13px;
    color: var(--text-secondary, #666);
    line-height: 1.6;
    background: #f8f9fa;
    border-color: #e8eaed;
    
    @media (max-width: 768px) {
        font-size: 12px;
        padding: 14px;
    }
`

export const ShiftContainer = styled.div`
    padding: 18px 16px;
    border-radius: 12px;
    background: var(--common-white-main, #fff);
    border: 1px solid var(--primary-blue, #0B4598);
    box-shadow: 0 2px 6px rgba(0,0,0,0.06);
    margin-bottom: 16px;
`

export const MarkAsPaidSection = styled.div`
    ${cardStyle}
    padding: 24px;
    text-align: center;
    
    .mark-paid-note {
        font-size: 14px;
        color: var(--text-secondary, #666);
        line-height: 1.6;
        margin-bottom: 20px;
    }

    .mark-paid-button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        width: 100%;
        margin: 0;
        padding: 14px 20px;
        background: var(--primary-blue, #0B4598);
        color: #ffffff;
        border: none;
        border-radius: 8px;
        font-weight: 600;
        font-size: 16px;
        cursor: pointer;
        box-shadow: 0 2px 6px rgba(11, 69, 152, 0.2);
        transition: background 0.2s, box-shadow 0.2s;
        
        &:hover {
            background: #093a7a;
            box-shadow: 0 4px 12px rgba(11, 69, 152, 0.3);
        }
    }
    
    @media (max-width: 768px) {
        padding: 20px;
        
        .mark-paid-note {
            font-size: 13px;
        }
        
        .mark-paid-button {
            font-size: 15px;
            padding: 12px 18px;
        }
    }
`

export const AlreadyPaidBanner = styled.div`
    ${cardStyle}
    padding: 24px;
    text-align: center;
    background: linear-gradient(135deg, #13CA82 0%, #0fb876 100%);
    border: none;
    color: #fff;
    
    h2 {
        margin: 0;
        font-size: 28px;
        font-weight: 700;
        text-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    
    p {
        margin: 8px 0 0 0;
        font-size: 14px;
        opacity: 0.95;
    }
    
    @media (max-width: 768px) {
        padding: 20px;
        
        h2 {
            font-size: 24px;
        }
    }
`

export const PaymentStatusBanner = styled.div<{ $tone: 'success' | 'processing' | 'attention' }>`
    ${cardStyle}
    padding: 24px;
    text-align: center;
    color: ${({ $tone }) => $tone === 'success'
        ? 'var(--dark-green, #1B5E20)'
        : $tone === 'attention'
            ? 'var(--warning-main, #EF6C00)'
            : 'var(--primary-blue, #0B4598)'};
    background: ${({ $tone }) => $tone === 'attention'
        ? 'var(--background-alternate, #FFFAF6)'
        : 'var(--background-success, #F1F7FF)'};
    border-color: ${({ $tone }) => $tone === 'success'
        ? 'var(--success-main, #13CA82)'
        : $tone === 'attention'
            ? 'var(--warning-main, #EF6C00)'
            : 'var(--info-main, #0288D1)'};

    h2 {
        margin: 0;
        font-size: 22px;
    }

    p {
        margin: 8px 0 0;
        font-size: 14px;
        line-height: 1.5;
    }
`
